/**
 * Use this to immediately invoke the callback with any current value and subscribe to changes.
 *
 * Does not support the event param of subscribe as the initial value would be ambiguous.
 */
define('common/ko/fn/subscribeAndExec',['knockout'], function(ko) {

    ko.subscribable.fn.subscribeAndExec = function (callback, callbackTarget) {

        var subscription = this.subscribe(function(value) {
            callback.call(this, value);
        }, callbackTarget);

        callback.call(callbackTarget || subscription, this.peek());

        return subscription;
    };

});

